<template lang="pug">
    div.expandCard
        table
            tr

                // User Full Name
                td {{ $t('fields.fullName') }}
                td {{ item.fullName }}

            tr
                // Business Name
                td {{ $t('fields.businessName') }}
                td {{ item.business ? item.business.name : '' }}

            tr
                // Days meditated
                td {{ $t('fields.daysMeditated') }}
                td {{ item.totalDailyViews }}

            tr
                // Completed sessions
                td {{ $t('fields.completed') }}
                td {{ item.completedSessions }}
</template>

<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';
    import phoneNumber from '~filters/Phone';
    import { mapGetters } from 'vuex';

    export default {
        filters: {
            formattedDate,
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({}),
            customFields: VueTypes.array.def([])
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin'])
        }
    };
</script>
